import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { IS_SAAS } from "@coso/utility";

@Injectable({
  providedIn: "root"
})
export class EnvironmentService {
  private baseRoute: string = `/api/environment`;

  private _configClientId: any;
  public get configClientId(): any {
    return this._configClientId;
  }

  private _configAzureAdClientId: any;
  public get configAzureAdClientId(): any {
    return this._configAzureAdClientId;
  }

  private _configAzureAdAdministrativeUnitClientId: any;
  public get configAzureAdAdministrativeUnitClientId(): any {
    return this._configAzureAdAdministrativeUnitClientId;
  }  

  constructor(@Inject(IS_SAAS) private isSaaS: boolean, private http: HttpClient) {}

  getDefaultClientId(): Observable<any> {
    if (this.isSaaS) {
      return this.configClientId ? of(this.configClientId) : this.http.get(`${this.baseRoute}/modern-authentication/default-client-id`);
    }

    return of(undefined);
  }

  getAzureAdDefaultClientId(): Observable<any> {
    if (this.isSaaS) {
      return this.configAzureAdClientId ? of(this.configAzureAdClientId) : this.http.get(`${this.baseRoute}/modern-authentication/azure-ad-client-id`);
    }
    
    return of(undefined);
  }

  getAzureAdAdministrativeUnitDefaultClientId(): Observable<any> {
    if (this.isSaaS) {
      return this.configAzureAdAdministrativeUnitClientId ? of(this.configAzureAdAdministrativeUnitClientId) : this.http.get(`${this.baseRoute}/modern-authentication/azure-ad-administrative-unit-client-id`);
    }
    
    return of(undefined);
  }

  async loadConfigClientId(): Promise<any> {
    try {
      const configClientId = await this.getDefaultClientId().toPromise();
      this._configClientId = configClientId;
      return configClientId;
    } catch (err) {
      this._configClientId = null;
    }

    try {
      const configAzureAdClientId = await this.getAzureAdDefaultClientId().toPromise();
      this._configAzureAdClientId = configAzureAdClientId;
      return configAzureAdClientId;
    } catch (err) {
      this._configAzureAdClientId = null;
    }

    try {
      const configAzureAdAdministrativeUnitClientId = await this.getAzureAdAdministrativeUnitDefaultClientId().toPromise();
      this._configAzureAdAdministrativeUnitClientId = configAzureAdAdministrativeUnitClientId;
      return configAzureAdAdministrativeUnitClientId;
    } catch (err) {
      this._configAzureAdAdministrativeUnitClientId = null;
    }
  }
}
